import { type SVGProps } from 'react';

import { cn } from '@shared/utils';

export interface ChevronDownIconProps extends SVGProps<SVGSVGElement> {
  className?: string;
}

export function ChevronDownIcon({ className, ...props }: Readonly<ChevronDownIconProps>) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn('text-[#00467D]', className)}
      aria-hidden="true"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.35147 8.35147C6.8201 7.88284 7.5799 7.88284 8.04853 8.35147L12 12.3029L15.9515 8.35147C16.4201 7.88284 17.1799 7.88284 17.6485 8.35147C18.1172 8.8201 18.1172 9.5799 17.6485 10.0485L12.8485 14.8485C12.3799 15.3172 11.6201 15.3172 11.1515 14.8485L6.35147 10.0485C5.88284 9.5799 5.88284 8.8201 6.35147 8.35147Z"
        fill="currentColor"
      />
    </svg>
  );
}
